import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SetStateAction, useEffect, useRef, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { loginApi } from "components/api/user";
import { alertControl, modalControl, successControl } from "util/commAction";
import Button from "components/button/default";
import { useAuthContext } from "components/context/authContext";
import ResetPwdModal from "../resetpwd";
import "./loginmd.scss";
import "../../view/login/login.scss";
import "../../layout/authLayout/authLayout.scss";

type IProps = {
  prevPath?: string;
  nextPath?: string;
};

export default function LoginModal({ prevPath, nextPath }: IProps) {
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { viewPort, userInf, setUserInf, onIsLoggedIn, onUserInf } =
    useAuthContext();

  const [emlId, setEmlId] = useState("");
  const [lgnPwd, setLgnPwd] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const pwdRef = useRef<HTMLInputElement | null>(null);

  //로그인
  const loginMutation = useMutation({
    mutationFn: loginApi,
    onSuccess: (res) => {
      if (res) {
        const { status, data } = res;

        successControl({
          status: status,
          success: () => {
            onIsLoggedIn(true);
            onUserInf({
              ...userInf,
              ...res.data,
              emlId,
            });
            navigate(prevPath || state?.prevPath || nextPath);
            modalControl({
              isOpen: false,
            });
          },
        });
      }
    },
  });

  const handleLogin = () => {
    loginMutation.mutate({
      emlId,
      lgnPwd,
    });
  };

  useEffect(() => {
    const emlId = localStorage.getItem("emlId");

    if (emlId) {
      setEmlId(emlId);
    }
  }, []);

  //ENTERKEY LOGIN
  // const handleEnterLogin = (event: KeyboardEvent) => {
  //   if (event.key == "Enter") {
  //     handleLogin();
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("keydown", handleEnterLogin);
  //   return () => {
  //     window.removeEventListener("keydown", handleEnterLogin);
  //   };
  // }, []);

  return (
    <div className={"auth-layout" + " " + viewPort?.screen}>
      <div className={"login-" + viewPort?.screen}>
        <h1 className="text-center">{t("ttl_lgi")}</h1>
        <div className="">
          <input
            type="text"
            className="mb-[12px]"
            placeholder={t("txt_eml_id_cmm")}
            name="emlId"
            value={emlId}
            required
            onChange={(e) => {
              setEmlId(e.currentTarget.value);
            }}
          />
          <input
            type={"password"}
            id="lgnPwd"
            className="mb-[12px]"
            placeholder={t("txt_pwd_cmm")}
            name={"lgnPwd"}
            ref={pwdRef}
            value={lgnPwd}
            required
            onChange={(e) => {
              setLgnPwd(e.currentTarget.value);
            }}
          />{" "}
          <label
            htmlFor="lgnPwd"
            onClick={(e) => {
              const clss = e.currentTarget.className;
              if (pwdRef.current) {
                if (clss === "on") {
                  pwdRef.current.type = "password";
                  e.currentTarget.className = "";
                }
                if (clss !== "on") {
                  pwdRef.current.type = "text";
                  e.currentTarget.className = "on";
                }
              }
            }}
          ></label>
          <ul className="flex justify-between px-[41px]">
            <li>
              <input
                type="checkbox"
                name="rm_eml"
                id="rm_eml"
                defaultChecked={!!localStorage.getItem("emlId")}
                onChange={(e) => {
                  if (!emlId) {
                    alertControl({
                      isOpen: true,
                      inner: t("alr_insert_pwd"),
                    });
                    e.preventDefault();
                    e.currentTarget.checked = false;
                    return;
                  }
                  const checked = e.currentTarget.checked;
                  if (checked) {
                    setUserInf({
                      ...userInf,
                      emlId,
                    });
                    localStorage.setItem("emlId", emlId + "");
                  }
                  if (!checked) {
                    localStorage.removeItem("emlId");
                  }
                }}
              />
              <label htmlFor="rm_eml">{t("chckbx_lbl_rm_eml")}</label>
            </li>
            <li
              onClick={() => {
                alertControl({
                  isOpen: true,
                  chk_btn: false,
                  innerHtml: <ResetPwdModal />,
                });
              }}
            >
              {t("btn_fnd_pss")}
            </li>
          </ul>
          <Button
            text={t("btn_lgi")}
            styels="w-full"
            disabled={!(emlId && lgnPwd)}
            onClick={handleLogin}
          />
          <p>
            {t("dscrp_no_mem")}&nbsp;&nbsp;
            <b>
              <Link to="">{t("lnk_join")}</Link>
            </b>
          </p>
        </div>
        <div className="btn-wrap">
          <Button
            text={"Apple" + " " + t("btn_id_lgi")}
            styels="apple"
            onClick={() => {}}
          />
          <Button
            text={"Goole" + " " + t("btn_id_lgi")}
            styels="google"
            onClick={() => {}}
          />
        </div>
      </div>
      <div className={"text-center"}>
        <p className="text-blue-300">MUSEUM</p>
        <sub className="text-[10px] text-gray-400 ">
          Copyright © 2023 by UBCompany Inc. All right reserved.
        </sub>
      </div>
      {/* <ResetPwdModal isOpen={isOpen} setIsOpen={setIsOpen} /> */}
    </div>
  );
}
